import instance from "./instance";
const practiceUrl = "/practice/v1/user";

export const getLearnStreakStatistics = () => {
  return instance.get(`${practiceUrl}/learn-streak/get-statistics`);
};
